import React from 'react';
import {
    PlanCurriculumTabContent,
    type PlanCurriculumTabContentProps
} from './PlanCurriculumTabContent';

export type AddTopicsTabContentProps = Omit<
    PlanCurriculumTabContentProps,
    'isStudentCurriculumActive' | 'noStudentsDescription' | 'showAddCustomMenu'
>;

/** Add Topics tab — provider curriculum browsing; Add Topics-specific empty copy. */
export function AddTopicsTabContent(props: AddTopicsTabContentProps) {
    return (
        <PlanCurriculumTabContent
            {...props}
            isStudentCurriculumActive={false}
            showAddCustomMenu
            noStudentsDescription="You need to create a student before you can add curriculum topics."
        />
    );
}
